module.exports = __webpack_public_path__ + "static/eg-d89ba3620f7a1abc972f941c319f2aa1.svg";